import React from "react";
import { TeamOutlined, UsergroupAddOutlined, SolutionOutlined, UserOutlined, ProfileOutlined, GlobalOutlined } from "@ant-design/icons";
import '../App.css';
const agencyIcons = [
  { icon: <TeamOutlined style={{ fontSize: "50px", color: "#6841eb" }} />, text: "Startups", subtitle: "Scale hiring quickly" },
  { icon: <UserOutlined style={{ fontSize: "50px", color: "#6841eb" }} />, text: "Independent Recruiters", subtitle: "4x productivity boost" },
  { icon: <SolutionOutlined style={{ fontSize: "50px", color: "#6841eb" }} />, text: "Mid-Sized Companies", subtitle: "Streamline operations" },
  { icon: <UsergroupAddOutlined style={{ fontSize: "50px", color: "#6841eb" }} />, text: "Recruitment Agencies", subtitle: "High-volume hiring" },
];

const RecruitmentAgencies = () => {
  return (
    <div className="recruitment-platform">
      <h2 className="platform-title">
        4x Productivity for Recruitment Teams
      </h2>
      <p style={{ textAlign: 'center', fontSize: '1.2rem', color: '#666', marginBottom: '50px', maxWidth: '700px', margin: '0 auto 50px auto', lineHeight: '1.6' }}>
        Built for recruitment teams handling high-volume hiring. From solo recruiters to growing agencies, ChronoFlow scales with your business needs.
      </p>
      <div className="logo-grid">
        {agencyIcons.map((agency, index) => (
          <div key={index} className="logo-card">
            {agency.icon}
            <p className="logo-text1">{agency.text}</p>
            <p className="logo-subtitle">{agency.subtitle}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecruitmentAgencies;
